import styled from 'styled-components';

export const LayoutContainer = styled.div`
  display: flex;
  flex: 1 0 auto;
  width: 100%;
  overflow-x: hidden;
  
  & .ant-page-header {
    padding: 16px 30px 16px 30px;
    
    @media (max-width: 1350px) {
      padding: 16px 15px 16px 15px;
    }
  }
  
  & .ant-page-header-heading-left {
    width: 100%
  }
`;

export default null;
